<div class="app-access-container">
  <div class="heading start">{{ 'tlc.members.add_member.roles.app_label' | translate }}</div>
  <div class="heading"></div>
  <div class="heading end">{{ 'tlc.members.add_member.roles.role_label' | translate }}</div>

  @if (isRecruiteeAvailable()) {
    <ng-container *ngTemplateOutlet="recruiteeRow" />
  }
  @if (isKiwiAvailable()) {
    <ng-container *ngTemplateOutlet="kiwiRow" />
  }
</div>

<ng-template #recruiteeRow>
  <div class="cell">
    <tln-ats-logo />
    <span class="brand-name"
      >{{ 'tlc.common.brand.recruitee' | translate }}&nbsp;<span class="brand-type">{{
        'tlc.common.brand_type.recruitee' | translate
      }}</span></span
    >
  </div>
  <div class="cell">
    <rt-toggle rtProtectedControl [formControl]="recruiteeFormGroup().controls.toggle" />
  </div>
  <div class="cell" layout-full-width>
    <rt-select
      rtProtectedControl
      [formControl]="recruiteeFormGroup().controls.roleExternalId"
      [options]="recruiteeSelectOptions()"
      [hideTextOverflow]="true"
      [emptyOptionLabel]="'-'"
      [emptyOptionValue]="'-'"
    />
  </div>
</ng-template>

<ng-template #kiwiRow>
  <div class="cell">
    <tln-hr-logo />
    <span class="brand-name"
      >{{ 'tlc.common.brand.hr' | translate }}&nbsp;<span class="brand-type">{{
        'tlc.common.brand_type.hr' | translate
      }}</span></span
    >
  </div>
  <div class="cell">
    <rt-toggle rtProtectedControl [formControl]="kiwiFormGroup().controls.toggle" />
  </div>
  <div class="cell" layout-full-width>
    <rt-select
      rtProtectedControl
      [formControl]="kiwiFormGroup().controls.roleExternalId"
      [options]="kiwiSelectOptionsWithMemberListed()"
      [hideTextOverflow]="true"
      [emptyOptionLabel]="'-'"
      [emptyOptionValue]="'-'"
    />
  </div>
</ng-template>

<ng-template #javeloRow>
  <div class="cell">
    <tln-javelo-logo />
    <span class="brand-name">{{ 'tlc.common.brand.javelo' | translate }}</span>
  </div>
  <div class="cell"><rt-toggle /></div>
  <div class="cell"><rt-select /></div>
</ng-template>
